import { __awaiter } from "tslib";
import isClient from "../../common/isClient";
import trackWithAndroidTracker from './trackWithAndroidTracker';
import trackWithIOSTracker from './trackWithIOSTracker';
import trackWithUtag from './trackWithUtag';
/**
 * Web analytics tracking function.
 * Will wait until the utag script is available and push data to tealium.
 * In case it is running in one of the native app touchpoints it will call the native tracker instead.
 *
 * @throws Error - If not running client side, or utag script is never found, or (for the case of apps) if one of the native trackers are never found.
 * @param method - The tealium method.
 * @param utagData - The page object that is required by tealium in every call.
 * @param options - If `forceUtagForIOS` and `forceUtagForAndroid` are set to true then this function will send the data using utag instead of native tracker on iOS and Android, respectivly.
 * @returns - A promise that succeeds when tracking has been performed.
 */
const trackEventBase = (method, utagData, options) => __awaiter(void 0, void 0, void 0, function* () {
    const { session_touchpoint: touchpoint } = utagData;
    if (!isClient()) {
        throw Error('trackEvent should be run only on client side');
    }
    const shouldUseNativeTracker = (touchpoint === 'IOS' && !(options === null || options === void 0 ? void 0 : options.forceUtagForIOS)) ||
        (touchpoint === 'ANDROID' && !(options === null || options === void 0 ? void 0 : options.forceUtagForAndroid));
    if (shouldUseNativeTracker) {
        if (touchpoint === 'IOS') {
            return trackWithIOSTracker(method, utagData, options);
        }
        return trackWithAndroidTracker(method, utagData, options);
    }
    return trackWithUtag(method, utagData, options);
});
export default trackEventBase;
//# sourceMappingURL=trackEventBase.js.map